<template>
  <GymDashboard />
</template>

<script>
import GymDashboard from '@/components/inicio_dashboard.vue'
export default {
  name: 'DashboardView',
  components: { GymDashboard }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/DashboardView.vue